import type { ReactNode } from 'react';

export const symbol_bookmark_bag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M441.5-358.5Q450-367 450-380v-10h60v10q0 13 8.5 21.5T540-350q13 0 21.5-8.5T570-380v-10q17 0 28.5-11.5T610-430v-170q0-17-11.5-28.5T570-640h-20v-50q0-17-11.5-28.5T510-730h-60q-17 0-28.5 11.5T410-690v50h-20q-17 0-28.5 11.5T350-600v170q0 17 11.5 28.5T390-390v10q0 13 8.5 21.5T420-350q13 0 21.5-8.5ZM450-640v-50h60v50h-60Zm30 400-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h440q24 0 42 18t18 42v574q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-64 220 93v-574H260v574l220-93Zm0-481H260h440-220Z"
		/>
	</svg>
);
